<script setup lang="ts">
import StatusPill from './StatusPill.vue'
import type { Tone } from '@/lib/presentation'

defineProps<{
	title: string
	/** Optional: the probed hostnames are deliberately not shown, see @/lib/brand. */
	subtitle?: string
	tone: Tone
	statusLabel: string
	pending?: boolean
	/** Explanation of the result, shown under the row once there is something to say. */
	detail?: string
}>()
</script>

<template>
	<div class="row-check">
		<div class="head">
			<div class="names">
				<span class="title">{{ title }}</span>
				<span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
			</div>
			<StatusPill :tone="tone" :label="statusLabel" :pending="pending" />
		</div>
		<p v-if="detail" class="detail">{{ detail }}</p>
		<div v-if="$slots.meta" class="meta">
			<slot name="meta" />
		</div>
	</div>
</template>

<style scoped>
.row-check {
	padding: 14px 0;
	border-bottom: 1px solid var(--tcx-line);
}

.row-check:last-child {
	border-bottom: 0;
}

.head {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 16px;
}

.names {
	display: flex;
	flex-direction: column;
	min-width: 0;
}

.title {
	font-weight: 500;
	color: var(--tcx-text);
}

.subtitle {
	font-size: 0.8125rem;
	color: var(--tcx-muted);
	word-break: break-all;
}

.detail {
	margin: 8px 0 0;
	max-width: 62ch;
	font-size: 0.875rem;
	color: var(--tcx-muted);
}

.meta {
	margin-top: 6px;
	font-size: 0.8125rem;
	color: var(--tcx-muted);
}
</style>
